'use client';
import { styled } from '@mui/material/styles';
import MuiRadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';

const StyledRadioGroup = styled(MuiRadioGroup)<RadioGroupProps>({});

export const RadioGroup = (props: RadioGroupProps) => <StyledRadioGroup {...props} />;
